import { Component, effect, inject } from "@angular/core";
import { Router } from "@angular/router";
import { Auditor } from "@app/Domain/Models/auditor.model";
import { AzureAdService } from "@core/services/azure-ad.service";
import { SessionStorageService } from "@core/services/session-storage.service";
import {
    LayoutService,
    ProfileSidebarBlockComponent,
    ProfileSidebarBlockItemComponent,
    ProfileSidebarBlockSubtitleComponent,
    ProfileSidebarBlockTitleComponent
} from "@iatec/nephos-layout";
import { TranslocoPipe } from "@jsverse/transloco";

@Component({
    selector: "app-main-template-profile-sidebar",
    imports: [
        TranslocoPipe,
        ProfileSidebarBlockComponent,
        ProfileSidebarBlockItemComponent,
        ProfileSidebarBlockTitleComponent,
        ProfileSidebarBlockSubtitleComponent
    ],
    templateUrl: "./profile-sidebar.component.html"
})
export class ProfileSidebarComponent {
    name: string | undefined;
    private _layoutService = inject(LayoutService);
    private azureAdService = inject(AzureAdService);
    private router = inject(Router);
    private sessionStorage = inject(SessionStorageService);
    private auditor: Auditor = this.sessionStorage.get("auditor");

    private readonly profileEffect = effect(() => {
        const profile = this._layoutService.profile();
        this.name = profile.name;
    });

    onCommentClick() {
        // console.log("Comment clicked");
    }

    onProfileClick() {
        this._layoutService.layoutState.update((prev) => ({
            ...prev,
            profileSidebarVisible: false
        }));

        this.router.navigate(["/Profile/register"], {
            queryParams: {
                action: "view",
                id: this.auditor.codAuditor
            }
        });
    }

    onSignOutClick() {
        this.azureAdService.logout();
    }
}
